import { render, staticRenderFns } from "./index.vue?vue&type=template&id=578513c5&scoped=true&"
import script from "./index.vue?vue&type=script&setup=true&lang=ts&"
export * from "./index.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=578513c5&prod&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=578513c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578513c5",
  null
  
)

export default component.exports